import { paths } from 'src/routes/paths';

export const HOST_API = import.meta.env.VITE_HOST_API;

export const FIREBASE_API = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APPID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  realtimeDatabaseUrl: import.meta.env.VITE_FIREBASE_REALTIME_DATABASE_URL,
};

export const SENTRY_ENABLED = import.meta.env.VITE_SENTRY_ENABLED;
export const SENTRY_DNS = import.meta.env.VITE_SENTRY_DNS;
export const SENTRY_ENVIRONMENT = import.meta.env.VITE_SENTRY_ENVIRONMENT;

export const PATH_AFTER_LOGIN = paths.overview.root;

export const WAITING_PRICE_BUY_BAHT_LIMIT = import.meta.env.VITE_WAITING_PRICE_BUY_BAHT_LIMIT;
export const WAITING_PRICE_SELL_BAHT_LIMIT = import.meta.env.VITE_WAITING_PRICE_SELL_BAHT_LIMIT;
export const WAITING_PRICE_BUY_GRAM_LIMIT = import.meta.env.VITE_WAITING_PRICE_BUY_GRAM_LIMIT;
export const WAITING_PRICE_SELL_GRAM_LIMIT = import.meta.env.VITE_WAITING_PRICE_SELL_GRAM_LIMIT;
